import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class RoadmapTableInitiativeIndexRoute extends Route {
  @service router;

  afterModel() {
    this.router.transitionTo('backlog.initiatives.initiative.description');
  }

  model() {
    return this.modelFor('backlog.initiatives.initiative');
  }
}

export default instrumentRoutePerformance(RoadmapTableInitiativeIndexRoute);
